<template>
  <div>
    <b-card :body-class="{ 'p-0': !nodata }" :header-class="{'border-0': !nodata, 'h5 text-black': true }">
      <template slot="header">
        <span class="icon icon-Mediums text-primary"/> {{ title || 'Report' }}
        <span class="float-right">
            <b-btn v-if="exportable && this.report.length > 0" @click="downloadCSV" class="py-0 mx-3" size="sm">Export CSV</b-btn>
            <span v-if="collapsible" v-b-toggle.tableCollapse class="cursor-pointer text-muted">–</span>
          </span>
      </template>
      <b-collapse id="tableCollapse" :visible="true">
        <report-table
          @page-change="pageChanged"
          :collapsible="true"
          :report="report"
          :stats="stats"
          :fields="fields"
          :interval="interval"
          :timezone="timezone"
          :graph-colors="graphColors"
          :currentPage="currentPage"
          :synced-with-graph="syncedWithGraph"
          :busy="loading"
          ref="table">
        </report-table>
      </b-collapse>
    </b-card>
    <b-pagination
      v-if="perPage > 0 && report.length > 0"
      class="mt-3"
      :total-rows="report.length"
      align="center"
      v-model="currentPage"
      :per-page="perPage">
    </b-pagination>
  </div>
</template>

<script>
    import ReportTable from '@/reports/components/ReportTable'

    export default {
        name: 'ReportTableCard',
        props: {
            loading: {required: false, type: Boolean, default: false},
            title: {required: false, type: String},
            report: {required: true, type: Array},
            stats: {required: true, type: Array},
            fields: {required: true, type: Array},
            interval: {required: false, type: String},
            graphColors: {required: false, type: Object},
            timezone: {required: false, type: String},
            collapsible: {required: false, default: false, type: Boolean},
            exportable: {required: false, default: false, type: Boolean},
            syncedWithGraph: {required: false, type: Boolean, default: false},
            loading: {type: Boolean, default: false}
        },
        data() {
            return {
                currentPage: 1,
                perPage: 10,
            }
        },
        computed: {
            nodata() {
                return this.loading === false && this.report.length === 0
            }
        },
        methods: {
            downloadCSV() {
                this.$refs.table.downloadCSV();
            },
            pageChanged(processedReport) {
                this.$emit('page-change', processedReport)
            },
            reset() {
                this.currentPage = 1
                if(!this.report || !this.report.length) {
                    return
                }

                this.$nextTick(function () {
                    this.$refs.table.reset();
                })
            },
        },
        components: {
            ReportTable
        }
    }
</script>



// WEBPACK FOOTER //
// src/reports/components/ReportTableCard.vue